import { DateTime } from "luxon";
import { QuotationRequestDestination, TripLeg } from "./definitions";

type QuotationTripLegProps = {
  tripLeg: TripLeg;
  destinations: QuotationRequestDestination[];
  excludedServiceUids: Set<string>;
  excludeTripLeg: () => void;
  includeTripLeg: () => void;
};

export function QuotationTripLeg({
  tripLeg,
  destinations = [],
  excludedServiceUids,
  excludeTripLeg,
  includeTripLeg,
}: QuotationTripLegProps) {
  const originDestination = destinations.find(
    (d) => d.order.toString() === tripLeg.origin_order.toString(),
  );
  const destinationDestination = destinations.find(
    (d) => d.order.toString() === tripLeg.destination_order.toString(),
  );

  return (
    <div className="grid gap-3 p-3 px-6 shadow-md rounded-md border border-gray-100">
      <div className="grid gap-3 overflow-y-auto p-3 rounded-md border border-purple-500 auto-rows-max">
        <h6>
          Transportation from {originDestination?.name_en} to {destinationDestination?.name_en}
        </h6>
        <div className="grid gap-3">
          <div className="inline-grid grid-cols-[1fr_max-content] gap-1">
            <span>
              <strong>Notes: </strong>
              {tripLeg?.service_preference?.notes}
            </span>
            <input
              type="checkbox"
              checked={!excludedServiceUids.has(tripLeg.uid)}
              className="self-center"
              onChange={(e) => {
                if (e.target.checked) {
                  includeTripLeg();
                } else {
                  excludeTripLeg();
                }
              }}
            />
          </div>
          <div className="grid gap-3 grid-cols-2">
            <span>
              <strong>Departure Date: </strong>
              {DateTime.fromISO(tripLeg.departure).toLocaleString(DateTime.DATE_MED)}
            </span>
            <span>
              <strong>Arrival Date: </strong>
              {DateTime.fromISO(tripLeg.arrival).toLocaleString(DateTime.DATE_MED)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
